import Swiper from 'swiper/bundle';

export default () => {
  function init() {
    const target = `#product-real-women`;
    new Swiper(target, {
      slidesPerView: 3,
      loop: true,
      spaceBetween: 40,
      centeredSlides: false,
      navigation: {
        nextEl: '.swiper-button-next--product-real-women',
        prevEl: '.swiper-button-prev--product-real-women',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: 'true',
      },
      breakpoints: {
        // when window width is >= 320px
        300: {
          slidesPerView: 1,
          spaceBetween: 0,
          centeredSlides: true,
          centeredSlidesBounds: true,
          freeModeSticky: true,
        },
        820: {
          slidesPerView: 2,
          spaceBetween: 0,
          centeredSlides: false,
        },
        1120: {
          slidesPerView: 3,
          centeredSlides: false,
        },
      },
    });
  }

  /**
   * Return immutable object.
   */
  return Object.freeze({
    init,
  });
};
